import React from 'react';
import {Nav} from "react-bootstrap";

function TabBar({children}) {
    return (
        <div className="custom-tab-bar">
            <Nav justify variant="tabs" defaultActiveKey="/home">
                {children}
            </Nav>
        </div>
    );
}

export default TabBar;
